/**
 * Created by lycheng on 2017/11/23.
 * 登陆成功之后拼接html
 */
import { config } from 'config'
import * as userApi from 'js/api/user'
import { getVip } from 'js/api/power'
import { getMemberLevel } from 'js/api/member'

function getHtml () {
  this.isWelfare = false
  this.isVip1 = false // 个人会员
  this.isVip2 = false // 企业会员
  this.vipLink = '/FunMember/center'
  this.level = 'L0'

  this.getVipClass = function () {
    let typeClass = 'no-vip'
    if (this.isVip1) {
      typeClass = 'personal-vip'
    } else if (this.isVip2) {
      typeClass = 'company-vip'
    } else {
      typeClass = 'no-vip'
    }
    return typeClass
  }

  this.getTypeClass = (info) => {
    let typeClass = 'uncerti'
    switch (info.certificate) {
      case '个人认证': {
        typeClass = 'personal'
        break
      }
      case '学生认证': {
        typeClass = 'student'
        break
      }
      case '创业团队认证': {
        typeClass = 'business-team'
        break
      }
      case '企业认证': {
        typeClass = 'company'
        break
      }
      default: {
        typeClass = 'uncerti'
      }
    }
    return typeClass
  }

  // 悬浮回调
  this.hoverCallBack = function (callback) {
    Promise.all([userApi.isWelfare(), getVip(), getMemberLevel()]).then(r => {
      this.isWelfare = r[0].data
      if (r[1].flag) {
        const d = r[1].data
        if (d) {
          if (d.bitMask === 1) {
            this.isVip1 = true
          }
          if (d.bitMask === 2) {
            this.isVip2 = true
          }
        } else {
          this.vipLink = '/FunMember'
        }
      }
      if (r[2].flag) {
        let d = r[2].data
        this.level = d.labelName
      }
    }).finally(() => {
      callback()
    })
  }

  this.renderHtml = function (userinfo) {
    return `<div class="header-control">
    <a class="header-link to-console" href="${config.CONSOLE}app/myapp" target="_blank">控制台</a>
  </div>
  <i class="icons icons-splite">|</i>
  <div class="header-userinfo">
    <a class="userinfo-name">
      <span class="name" title="${userinfo.userName}">
         ${userinfo.userName}
         <span style="position: absolute;bottom: 50%;left: 100%;margin-left: -25px;" class="badge ${!userinfo.msgCount || userinfo.msgCount === '0' ? '' : 'show-badge'}">${userinfo.msgCount}</span>
      </span>
    </a>
    <div class="userinfo-detail">
      <div class="userinfo-top userinfo-item-box">
        <div class="userinfo-email" title="${userinfo.email ? userinfo.email : ''}"><span class="us-email">${userinfo.email ? userinfo.email : ''}</span></div>
        <div class="certi-area">
          ${this.isWelfare
    ? `<div class="certi-every certi-welfare" elink="http://startups.xfyun.cn/gongyi">
            <div class="icon-cert welfare-icon"></div>
            <span>三声有幸</span>
          </div>` : ``}
          <div class="certi-every certi-${this.getTypeClass(userinfo)}" elink="${userinfo.toCertificate}">
            <div class="icon-cert ${this.getTypeClass(userinfo)}-icon"></div>
            <span>${userinfo.certificate}</span>
          </div>
          <div class="certi-every certi-${this.getVipClass()}" elink="${this.vipLink}">
            <div class="icon-cert ${this.getVipClass()}-icon"></div>
            <span>乐享会员</span>
          </div>
        </div>
      </div>
      <div class="userinfo-middle userinfo-item-box">
        <div class="userinfo-balance-wrap">
          <div class="userinfo-charge">
            <span>
              <svg class="icons-svg">
                <use xlink:href="#icon-dollor"></use>
              </svg>
              余额
            </span>
            <a class="link to-charge" href="${config.CONSOLE}center/charge" target="_blank">
              立即充值
            </a>
          </div>
          <span class="userinfo-balance">¥${userinfo.balance}</span>
        </div>
        <a class="userinfo-link" href="/customerLevel" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-star"></use>
          </svg>
          用户等级中心
          <span class="level-icon">${this.level}</span>
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}app/myapp" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-appmanage"></use>
          </svg>
          我的应用
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}center/cart" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-cart"></use>
          </svg>
          我的购物车
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}center/order" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-order"></use>
          </svg>
          订单管理
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}user/personaldata" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-user"></use>
          </svg>
          基本资料
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}workorder/myworkorder" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-workorder"></use>
          </svg>
          我的工单
        </a>
        <a class="userinfo-link" href="${config.CONSOLE}user/msgcenter" target="_blank">
          <svg class="icons-svg">
            <use xlink:href="#icon-mail"></use>
          </svg>
          站内消息<span class="badge ${!userinfo.msgCount || userinfo.msgCount === '0' ? '' : 'show-badge'}">${userinfo.msgCount}</span>
        </a>
      </div>
      <div class="userinfo-bottom userinfo-item-box">
        <a class="userinfo-link to-logout" href="javascript:void(0)">
          <svg class="icons-svg">
            <use xlink:href="#icon-logout"></use>
          </svg>
          退出登录
        </a>
      </div>
    </div>
  </div>`
  }
}

export default getHtml



// WEBPACK FOOTER //
// ./src/js/libs/utils-login-html.js